import { Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { getPdfSource } from 'src/utils/file';
import DocumentViewer from './DocumentViewer';

interface DocumentViewerContainerProps {
  fileUrl?: string;
  fileExtension?: string;
  submissionContextId?: string;
  organizationId?: string;
}

const SUPPORTED_EXTENSIONS = new Set([
  'pdf',
  'doc',
  'docx',
  'ppt',
  'pptx',
  'xls',
  'xlsx',
  'txt'
]);

export function DocumentViewerContainer({
  fileUrl,
  fileExtension,
  submissionContextId,
  organizationId
}: DocumentViewerContainerProps) {
  const [fileSource, setFileSource] = useState<string>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    setFileSource(undefined);
    setError(undefined);

    if (!fileUrl || !fileExtension) {
      return;
    }

    const normalizedExtension = fileExtension.toLowerCase();
    if (!SUPPORTED_EXTENSIONS.has(normalizedExtension)) {
      setError(
        'File format not supported for preview. Please download to view this file.'
      );
      return;
    }

    getPdfSource(fileUrl, { submissionContextId, organizationId })
      .then(setFileSource)
      .catch(() => {
        setError('Unable to load document.');
      });
  }, [fileUrl, fileExtension, organizationId, submissionContextId]);

  if (error || !fileUrl) {
    return <Text>{error ?? 'No document available.'}</Text>;
  }

  if (fileUrl && !fileSource) {
    return <Text>Loading document...</Text>;
  }

  return <DocumentViewer file={fileSource!} />;
}

